(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lb-retailer-login/assets/javascripts/change-password.js') >= 0) return;  svs.modules.push('/modules/lb-retailer-login/assets/javascripts/change-password.js'); 'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const {
  useState,
  useEffect
} = React;
const {
  jupiter,
  userSession
} = svs.core;
const {
  Button
} = svs.ui;
const {
  MessageBox
} = svs.components;
const {
  url
} = svs.lb_retailer_login.data.login;

const showMessageBox = ({
  message = 'Var vänlig försök igen senare.',
  title = 'Tekniskt fel'
} = {}) => {
  MessageBox.show({
    title,
    message,
    type: MessageBox.Type.ERROR,
    buttons: [{
      type: MessageBox.ButtonType.OK,
      text: 'Stäng'
    }],
    show: true
  });
};

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [formError, setFormError] = useState({});
  const [hasTouched, setHasTouched] = useState(false);
  useEffect(() => {
    function validatePassword() {
      const errors = {};

      if (!/\d/.test(newPassword)) {
        errors.newPassword = 'Nya lösenordet måste innehålla minst 1 siffra.';
      } else if (!/\D/.test(newPassword)) {
        errors.newPassword = 'Nya lösenordet måste innehålla minst 1 bokstav.';
      } else {
        errors.newPassword = '';
      }

      if (newPassword !== confirmPassword) {
        errors.confirmPassword = 'Lösenorden stämmer inte överens.';
      } else {
        errors.confirmPassword = '';
      }

      if (Object.keys(errors).filter(s => Boolean(errors[s])).length > 0) {
        errors.stopLogin = true;
      } else {
        errors.stopLogin = false;
      }

      return errors;
    }

    const clientValidationErrors = validatePassword();
    setFormError(errors => _objectSpread(_objectSpread({}, errors), clientValidationErrors));
  }, [currentPassword, newPassword, confirmPassword]);

  function handleSubmit(e) {
    e.preventDefault();

    function onLoginSuccess() {
      location.href = url;
    }

    function onLoginError(response) {
      switch (Number(response.responseJSON.error.code.replace(/\s/, ''))) {
        case 6243:
          setFormError(_objectSpread(_objectSpread({}, formError), {}, {
            currentPassword: 'Fel lösenord.'
          }));
          break;

        case 6124:
          setFormError(_objectSpread(_objectSpread({}, formError), {}, {
            newPassword: 'Lösenordet får inte vara identiskt med ditt nuvarande lösenord.',
            currentPassword: ''
          }));
          break;

        case 6125:
          setFormError(_objectSpread(_objectSpread({}, formError), {}, {
            newPassword: 'Lösenordet är för kort.',
            currentPassword: ''
          }));
          break;

        default:
          showMessageBox();
      }
    }

    setHasTouched(true);

    if (formError.stopLogin) {
      return;
    }

    jupiter.put({
      path: '/user/1/password',
      data: {
        oldPassword: currentPassword,
        newPassword
      }
    }, onLoginSuccess, onLoginError);
  }

  return React.createElement("div", {
    className: "bg-white border-grey-300 padding-3",
    style: {
      width: 465,
      borderWidth: 1,
      borderStyle: 'solid',
      marginLeft: 'auto',
      marginRight: 'auto',
      borderRadius: 4
    }
  }, React.createElement("form", {
    autoComplete: "off",
    onSubmit: handleSubmit
  }, React.createElement("h1", {
    className: "f-800 margin-bottom-1",
    style: {
      fontSize: 22
    }
  }, "Du beh\xF6ver byta l\xF6senord"), React.createElement("p", null, "Ditt eng\xE5ngsl\xF6senord beh\xF6ver bytas till ett som du sj\xE4lv v\xE4ljer."), React.createElement("div", {
    className: "control-group".concat(formError.currentPassword && hasTouched ? ' error' : '')
  }, React.createElement("div", {
    className: "has-input-action input-action-has-label js-input-action-show-password"
  }, React.createElement("label", {
    htmlFor: "current_password"
  }, "NUVARANDE L\xD6SENORD"), React.createElement("i", {
    className: "js-input-action input-action"
  }), React.createElement("input", {
    className: "js-input std-input qa-current-password",
    id: "current_password",
    onChange: e => {
      setCurrentPassword(e.target.value);
    },
    required: true,
    type: "password",
    value: currentPassword
  })), React.createElement("div", {
    className: "error-message"
  }, formError.currentPassword)), React.createElement("div", {
    className: "control-group".concat(formError.newPassword && hasTouched ? ' error' : '')
  }, React.createElement("div", {
    className: "has-input-action input-action-has-label js-input-action-show-password"
  }, React.createElement("label", {
    htmlFor: "new_password"
  }, "NYTT L\xD6SENORD"), React.createElement("i", {
    className: "js-input-action input-action"
  }), React.createElement("input", {
    className: "js-input std-input qa-new-password",
    id: "new_password",
    minLength: 2,
    onChange: e => {
      setNewPassword(e.target.value);
    },
    required: true,
    type: "password",
    value: newPassword
  })), React.createElement("div", {
    className: "error-message"
  }, formError.newPassword)), React.createElement("div", {
    className: "control-group margin-bottom-2".concat(formError.confirmPassword && hasTouched ? ' error' : '')
  }, React.createElement("div", {
    className: "has-input-action input-action-has-label js-input-action-show-password"
  }, React.createElement("label", {
    htmlFor: "confirm_password"
  }, "UPPREPA NYTT L\xD6SENORD"), React.createElement("i", {
    className: "js-input-action input-action"
  }), React.createElement("input", {
    className: "js-input std-input qa-confirm-password",
    id: "confirm_password",
    minLength: 2,
    onChange: e => {
      setConfirmPassword(e.target.value);
    },
    required: true,
    type: "password",
    value: confirmPassword
  })), React.createElement("div", {
    className: "error-message"
  }, formError.confirmPassword)), React.createElement("div", {
    className: "grid-row"
  }, React.createElement("div", {
    className: "col-xs-6 padding-xs-right-1"
  }, React.createElement(Button, {
    block: true,
    className: "qa-cancel",
    onClick: () => userSession.logout(),
    transparent: true
  }, "AVBRYT")), React.createElement("div", {
    className: "col-xs-6 padding-xs-left-1"
  }, React.createElement(Button, {
    block: true,
    className: "qa-login",
    focus: true,
    type: "submit"
  }, "BYT L\xD6SENORD")))));
};

setGlobal('svs.lb_retailer_login.ChangePassword', ChangePassword);
 })(window);